import axios from "axios";
import { useApi } from "../hooks/useApi";

const api = useApi();

export async function getTrocsRequestsList() {
  try {
    const response = await api.get(`trocs-requests-travelers/list`);
    return response;

  } catch (error) {

    throw error;
  }
}

export async function trocRequestCancel(trocRId: number, trocTId: number) {
  try {
    const response = await api.delete(`trocs-requests-travelers/trocRId/${trocRId}/trocTId/${trocTId}/canceling`);

    return response;

  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        switch (error.response?.status) {
          case 400:
            throw new Error(`${error.response.data.message}`);
          case 500:
            throw new Error(`Une erreur est suvenue. Rééssayez plus tard.`);
          default:
            throw new Error(`Une erreur est survenue.`);
        }
      }
      else if (error.request) {
        throw new Error(`Une erreur est survenue.`);
      }
      else if (axios.isCancel(error)) {
        throw new Error(`Une erreur est survenue.`);
      }
      else {
        // Ici on cast `error` comme un objet contenant un message
        throw new Error(`Une erreur est survenue.`);
      }
    } else {
      // Gère les erreurs non Axios (par exemple, erreur JavaScript générique)
      throw new Error(`Une erreur est survenue.`);
    }
  }
}

export async function trocRequestDelete(trocRId: number, trocTId: number) {
  try {
    const response = await api.delete(`trocs-requests-travelers/trocRId/${trocRId}/trocTId/${trocTId}/deleting`);

    return response;

  } catch (error) {
    throw error;
  }
}

export async function ServiceRendering(trocRId: number, trocTId: number) {
  try {
    const response = await api.put(`trocs-requests-travelers/trocRId/${trocRId}/trocTId/${trocTId}/service-done`);

    return response;

  } catch (error) {
    throw error;
  }
}

export async function shareExp(data: { content: string }, trocRId: number, trocTId: number) {
  try {
    const response = await api.put(`trocs-requests-travelers/trocRId/${trocRId}/trocTId/${trocTId}/share-exp`, data);

    return response;

  } catch (error) {
    throw error;
  }
}

export async function makeTrocRequest(travTrocId: number, resTrocId: number) {
  try {
    const response = await api.post(`trocs-requests-travelers/trav-make-a-request/trav-element/${travTrocId}/res-element/${resTrocId}`);
    return response.status;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Vérifier si l'erreur vient d'une requête Axios
      if (error.response) {
        // La réponse de l'API a été reçue, mais il y a eu un problème
        switch (error.response.status) {
          case 401:
            // Erreur abonnement invalide
            throw new Error("Une erreur est survenue");
          case 500:
            // Erreur serveur (interne)
            throw new Error("Une erreur est survenue");
          case 400:
            throw new Error(`${error.response.data.message}`);
          default:
            // Autres erreurs HTTP
            throw new Error("Une erreur est survenue");
        }
      }
      else if (error.request) {
        // Aucune réponse n'a été reçue (problème réseau ou timeout)
        throw new Error("Une erreur est survenue");
      }
      else {
        // Erreur lors de la préparation de la requête
        throw new Error("Une erreur est survenue");
      }
    }
    else {
      // Erreur non liée à Axios
      throw new Error("Une erreur est survenue");
    }
  }
}